import { render } from "./AuthFormSubmit.vue?vue&type=template&id=cd23c574"
import script from "./AuthFormSubmit.vue?vue&type=script&lang=js"
export * from "./AuthFormSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__